import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';

import { VFText, VFButton, Label, VFItem } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  LightThemeColors,
  getThemeImages,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import LoginTestKeys from '../../../Utils/LoginTestKeys';
import EditAccount from '../EditAccount';

import styles from './SavedAccountsView.Styles';

class SavedAccountsView extends Component {
  state = {
    isModalVisible: false,
    isBorderVisible: false,
  };

  onEditAccountPress = () => {
    this.toggleModal();
  };

  onScrollHandling = ({ nativeEvent }) => {
    if (nativeEvent.contentOffset.y <= 0) {
      this.setState({
        isBorderVisible: false,
      });
    } else {
      this.setState({
        isBorderVisible: true,
      });
    }
  };

  toggleModal = () => {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
    });
  };

  render() {
    const {
      savedAccounts,
      onAccountPress,
      images,
      getAccountIconBasedOnType,
      theme,
      onUpfrontLogin,
      onDeleteAccount,
    } = this.props;
    const { isBorderVisible, isModalVisible } = this.state;
    return (
      <>
        <EditAccount
          isModalVisible={isModalVisible}
          toggleModal={this.toggleModal}
          savedAccounts={savedAccounts}
          images={images}
          getAccountIconBasedOnType={getAccountIconBasedOnType}
          onDeleteAccount={onDeleteAccount}
          onUpfrontLogin={onUpfrontLogin}
        />

        <View>
          <VFText
            i18nKey={'registered_account_your_accounts_label'}
            placeHolders={[savedAccounts.length]}
            style={styles.title(theme)}
          />

          <ScrollView
            nestedScrollEnabled
            style={[styles.scrollViewStyle, isBorderVisible ? styles.scrollViewBorder(theme) : {}]}
            onScroll={this.onScrollHandling}
          >
            {savedAccounts.map(account => (
              <VFItem
                leftIcon={images[getAccountIconBasedOnType(account.accountType)]}
                rightIcon={getThemeImages(theme.name).ic_chevron_right}
                leftIconSize={33}
                rightIconSize={33}
                nameTextStyle={styles.accountNameText}
                {...account}
                onPress={onAccountPress}
                images={images}
                containerStyle={styles.itemContainerStyle}
                vfTextProps={{ testKey: LoginTestKeys.accountNameText }}
              />
            ))}
          </ScrollView>

          <Label
            title="registered_account_edit_your_account_list_label"
            style={styles.editAccount}
            textStyle={styles.editAccountTextStyle(theme)}
            onPress={this.onEditAccountPress}
            secondLabelTestId={LoginTestKeys.editAccountBtn}
          />

          <VFButton
            testID={LoginTestKeys.loginNextButton}
            title="registered_account_log_in_another_account_button"
            style={styles.button}
            onPress={onUpfrontLogin}
            type="secondary"
            textAccessibilityLabel={LoginTestKeys.loginNextButton}
          />
        </View>
      </>
    );
  }
}

SavedAccountsView.defaultProps = {
  theme: LightThemeColors,
  savedAccounts: [],
};

SavedAccountsView.propTypes = {
  theme: PropTypes.object,
  savedAccounts: PropTypes.array,
  onAccountPress: PropTypes.func,
  images: PropTypes.object,
  getAccountIconBasedOnType: PropTypes.func,
  onUpfrontLogin: PropTypes.func,
  onDeleteAccount: PropTypes.func,
};

export default withTheme(SavedAccountsView);
